/*
 * 1DS JS SDK POST plugin, 3.2.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 * (Microsoft Internal Only)
 */
export var Method = "POST";
export var DisabledPropertyName = "Microsoft_ApplicationInsights_BypassAjaxInstrumentation";
export var strDropped = "drop";
export var strSending = "send";
export var strRequeue = "requeue";
export var strResponseFail = "rspFail";
export var strOther = "oth";
export var defaultCacheControl = "no-cache, no-store";
export var defaultContentType = "application/x-json-stream";
export var strCacheControl = "cache-control";
export var strContentTypeHeader = "content-type";
export var strKillTokensHeader = "kill-tokens";
export var strKillDurationHeader = "kill-duration";
export var strKillDurationSecondsHeader = "kill-duration-seconds";
export var strTimeDeltaHeader = "time-delta-millis";
export var strClientVersion = "client-version";
export var strClientId = "client-id";
export var strTimeDeltaToApply = "time-delta-to-apply-millis";
export var strUploadTime = "upload-time";
export var strApiKey = "apikey";
export var strMsaDeviceTicket = "AuthMsaDeviceTicket";
export var strAuthXToken = "AuthXToken";
export var strSdkVersion = "sdk-version";
export var strNoResponseBody = "NoResponseBody";
export var strMsfpc = "msfpc";
//# sourceMappingURL=Constants.js.map